import apiClient from "./apiClient";

const onboardingService = {
  getStatus: async () => {
    const response = await apiClient.get("user/onboarding");
    return response.data;
  },

  updateStatus: async (payload) => {
    const response = await apiClient.put("user/onboarding", payload);
    return response.data;
  },
};

export default onboardingService;
